import { render, staticRenderFns } from "./CheckboxWithLabel.vue?vue&type=template&id=6830a7db&scoped=true&lang=html"
import script from "./CheckboxWithLabel.vue?vue&type=script&lang=ts"
export * from "./CheckboxWithLabel.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxWithLabel.vue?vue&type=style&index=0&id=6830a7db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.99.8__lodash@4.17.21_prettier@2.8.8_vue-_69bc0556815cefdff9c73fe5644cf446/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830a7db",
  null
  
)

/* custom blocks */
import block0 from "./CheckboxWithLabel.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports